const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let AutoFocusInput, TodoListPage;

let { TodoListItem } = require('./TodoListItem.blop');

AutoFocusInput = (state) => {let hooks;
  hooks = ({ insert: (vnode) =>vnode.elm.focus() });
  const __1c = []; const __1a = {}; __1a['hooks'] = hooks; __1a['type'] = 'text'; __1a['value'] = state.value; __1a['class'] = 'form-control'; __1a['on'] = state.on; __1a['autofocus'] = true; __1a['style'] = ({ fontSize: '16px', padding: '0.5em' }); const __1 = blop.h('input', __1a, __1c); return __1;
};

TodoListPage = (attributes, _children, node) => {let addItem, change, editItem, changeItem, remove;
  let { todo } = attributes;

  function unselect() {
    if (todo.editItemIndex !== false) {
      todo.editItemIndex = false;
    }
  };

  node.mount(() => {
    console.log('mount TodoListPage');
    document.addEventListener('click', unselect);
  }).unmount(() => {
    console.log('unmount TodoListPage');
    document.removeEventListener('click', unselect);
  });

  addItem = (e) => {
    e.preventDefault();
    if (todo.inputValue) {
      todo.todoList.push(todo.inputValue);
      todo.inputValue = '';
    }
  };
  change = (e) => {
    todo.inputValue = e.target.value;
  };

  editItem = (index) =>(e) => {
    e.stopPropagation();
    todo.editItemIndex = index;
  };
  changeItem = (index) =>(e) => {
    todo.editItemIndex = false;
    todo.todoList[index] = e.target.value;
  };
  remove = (index) =>() => {
    todo.editItemIndex = false;
    todo.todoList.splice(index, 1);
  };
  const __2c = []; const __2a = {};
    const __3c = []; const __3a = {}; __3a['on'] = ({ submit: addItem });
      const __4c = []; const __4a = {}; __4a['class'] = 'form-row';
        const __5c = []; const __5a = {}; __5a['class'] = 'col';
          const __6c = []; const __6a = {}; __6a['value'] = todo.inputValue; __6a['on'] = ({ change }); const __6 = blop.c(AutoFocusInput, __6a, __6c, '__6'); __5c.push(__6);
         const __5 = blop.h('div', __5a, __5c); __4c.push(__5);
        const __7c = []; const __7a = {}; __7a['class'] = 'col';
          const __8c = []; const __8a = {}; __8a['type'] = 'button'; __8a['class'] = 'btn btn-primary'; __8a['on'] = ({ click: addItem }); const __9 = 'Add to list'; Array.isArray(__9) ? __8c.push(...__9) : __8c.push(__9); const __8 = blop.h('button', __8a, __8c); __7c.push(__8);
         const __7 = blop.h('div', __7a, __7c); __4c.push(__7);
       const __4 = blop.h('div', __4a, __4c); __3c.push(__4);
     const __3 = blop.h('form', __3a, __3c); __2c.push(__3);
    const __10c = []; const __10a = {};
      let __11 = todo.todoList; let __12 = Object.keys(__11); let index; for(let __13=0; __13 < __12.length; __13++) { index = __12[__13]; let value = __11[index];
        const __14c = []; const __14a = {}; __14a['removeItem'] = remove(index); __14a['editItem'] = editItem(index); __14a['changeItem'] = changeItem(index); __14a['editMode'] = todo.editItemIndex === index; __14a['todo'] = todo; __14a['value'] = value; const __14 = blop.c(TodoListItem, __14a, __14c, '__14'); __10c.push(__14);
      };
     const __10 = blop.h('ul', __10a, __10c); __2c.push(__10);
   const __2 = blop.h('div', __2a, __2c); return __2;
};

module.exports = { TodoListItem, AutoFocusInput, TodoListPage };
